<template>
  <div>
    <el-row type="flex" justify="space-around" style="font-size: 35px; margin-top: 10px">
      <el-col style="text-align: left; line-height: 50px" :span="10">
        <span>IP:</span>
      </el-col>
      <el-col :span="12">
        <el-input
          @mousedown="$event.preventDefault()"
          @focus="handleIpClick"
          v-model="ip"
          placeholder=""
        ></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-around" style="font-size: 35px; margin-top: 10px">
      <el-col style="text-align: left; line-height: 50px" :span="10">
        <span>Folder:</span>
      </el-col>
      <el-col :span="12">
        <el-input
          @mousedown="$event.preventDefault()"
          @focus="handleFolderClick"
          v-model="folder"
          placeholder=""
        ></el-input>
      </el-col>
    </el-row>
    <el-row slot="footer" class="dialog-footer">
      <el-button type="info" @click="commitConfig">{{ $t("langcfg.txtSave") }}</el-button>
      <el-button type="info" @click="cancel">{{ $t("langcfg.txtCancel") }}</el-button>
    </el-row>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
export default {
  data() {
    return {
      ip: "",
      folder: ""
    };
  },
  methods: {
    handleIpClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.ip, (value) => {
        self.ip = value;
      });
    },
    handleFolderClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.folder, (value) => {
        self.folder = value;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/ShareDisk.vue